<div *ngIf="!isLoading; else loading">
  <div *ngIf="!errorOccurred; else error">
    <h4>Sesiones previas</h4>
    <div class="table-responsive mt-md-2 mt-sm-0">
      <table class="table table-sm t-elevated-shadow-cap">
        <thead>
          <tr>
            <th scope="col">Sesi&oacute;n</th>
            <th scope="col">Localizador</th>
            <th scope="col">Instructor</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let element of duplicateAttendance
                | slice: (page - 1) * pageSize : page * pageSize
            ">
            <td>{{ element.nombreSesion }}</td>
            <td>{{ element.idLocalizador }}</td>
            <td>{{ element.nombreInstructor }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- pagination -->
    <div class="d-flex justify-content-between p-2">
      <ngb-pagination
        [collectionSize]="collectionSize"
        [(page)]="page"
        [pageSize]="pageSize"
        [maxSize]="5"
        [rotate]="true"
        [boundaryLinks]="true">
      </ngb-pagination>

      <select class="form-select" style="width: auto" [(ngModel)]="pageSize">
        <option [ngValue]="5">5 registros por pagina</option>
        <option [ngValue]="10">10 registros por pagina</option>
        <option [ngValue]="20">20 registros por pagina</option>
      </select>
    </div>
    <div class="d-flex justify-content-center align-content-center mb-2 mt-3">
      <div class="col-8 mx-1 p-1">
        <button type="button" class="btn btn-primario" (click)="onClose()">
          <span> Cerrar </span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- loader -->
<ng-template #loading>
  <app-loading-spinner></app-loading-spinner>
</ng-template>
<!-- error on loading -->
<ng-template #error>
  <div
    class="d-flex flex-column align-items-center mb-2 mt-3 text-center"
    *ngIf="errorOccurred">
    <div>
      <h3 class="form-text text-danger mt-3">
        Ha ocurrido un error al obtener la informaci&oacute;n.
      </h3>
    </div>
  </div>
</ng-template>
